<template>
  <div class="general-spinner-parent">
    <div class="wrap-custom-progress">
      <div class="wrap-spinner">
        <div class="spinner" />
        <h3>
          <slot />
        </h3>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Spinner',
})
</script>
